// Client-side saved delivery addresses (localStorage-scoped, no auth needed).
// Keeps up to MAX entries, dedupes by (pincode + normalised address_line1),
// and orders by last_used_at desc.

const KEY = "tco_addresses_v1";
const MAX = 8;

function normalize(a) {
  return {
    id: a.id || (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`),
    label: a.label || null,
    address_line1: a.address_line1 || "",
    address_line2: a.address_line2 || "",
    area: a.area || "",
    city: a.city || "",
    state: a.state || "",
    pincode: a.pincode || "",
    landmark: a.landmark || "",
    instructions: a.instructions || "",
    lat: typeof a.lat === "number" ? a.lat : null,
    lng: typeof a.lng === "number" ? a.lng : null,
    geo_source: a.geo_source || null,
    last_used_at: a.last_used_at || new Date().toISOString(),
  };
}

export function loadAddresses() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function fingerprint(a) {
  return `${(a.pincode || "").trim()}::${(a.address_line1 || "").trim().toLowerCase()}`;
}

export function saveAddress(addr) {
  const list = loadAddresses();
  const item = normalize({ ...addr, last_used_at: new Date().toISOString() });
  const fp = fingerprint(item);
  const idx = list.findIndex((a) => fingerprint(a) === fp);
  if (idx >= 0) {
    list[idx] = { ...list[idx], ...item, id: list[idx].id };
  } else {
    list.unshift(item);
  }
  list.sort((a, b) => new Date(b.last_used_at) - new Date(a.last_used_at));
  const capped = list.slice(0, MAX);
  try { localStorage.setItem(KEY, JSON.stringify(capped)); } catch {}
  return capped;
}

export function removeAddress(id) {
  const list = loadAddresses().filter((a) => a.id !== id);
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
  return list;
}

/** Best-effort short label for a saved address chip. */
export function addressLabel(a) {
  if (a.label) return a.label;
  const first = (a.address_line1 || "").split(",")[0].trim();
  return first || a.area || a.city || a.pincode || "Address";
}

/** One-line summary for the chip subtitle. */
export function addressSummary(a) {
  return [a.address_line2, a.area, a.city, a.pincode].filter(Boolean).join(" · ");
}
